import { useEffect, useState } from 'react';
import Accordion from '../Accordion';
import CheckboxMultiple from '../CheckBoxMultiple';
import ArrowForward from '../Icons/ArrowForward';
import DropDownArrow from '../Icons/DropDownArrow';
import DropUpArrow from '../Icons/DropUpArrow';
import BtnConfirm from '../BtnConfirm';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../store';
import { useRouter } from 'next/router';

interface IOptionsFilter {
  value: string;
  label: string;
}
interface Props {
  filterOptions: {
    filterType: IOptionsFilter[];
    filterStatus: IOptionsFilter[];
  };
  filterTransactionType: string[];
  filterTransactionStatus: string[];
  onSubmit: (filterType: string[], filterStatus: string[]) => void;
  isDefaultOpen?: boolean;
}

function FilterModalTrackingTransaction({
  filterOptions,
  filterTransactionType,
  filterTransactionStatus,
  onSubmit,
  isDefaultOpen = false,
}: Props) {
  const router = useRouter();

  const { isLargeScreen } = useSelector((state: IRootState) => state.page);
  const [containerFilterType, setContainerFilterType] = useState<string[]>(filterTransactionType);
  const [containerFilterStatus, setContainerFilterStatus] =
    useState<string[]>(filterTransactionStatus);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      // Use visual viewport height instead of window.innerHeight
      const height = window.visualViewport?.height || window.innerHeight;
      setWindowHeight(height);
    };

    window.visualViewport?.addEventListener('resize', handleResize);
    window.visualViewport?.addEventListener('scroll', handleResize);

    // Fallback for browsers without visualViewport API
    if (!window.visualViewport) {
      window.addEventListener('resize', handleResize);
    }

    return () => {
      window.visualViewport?.removeEventListener('resize', handleResize);
      window.visualViewport?.removeEventListener('scroll', handleResize);
      if (!window.visualViewport) {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, []);

  const onChangeFilterType = ({ value, checked }) => {
    if (checked === true) {
      const nextFilterType = [...containerFilterType, value];

      setContainerFilterType(nextFilterType);
    } else {
      const indexItem = containerFilterType.findIndex((val) => val === value);

      const nextFilterType = [...containerFilterType];
      nextFilterType.splice(indexItem, 1);

      setContainerFilterType(nextFilterType);
    }
  };

  const onChangeFilterStatus = ({ value, checked }) => {
    if (checked === true) {
      const nextFilterStatus = [...containerFilterStatus, value];

      setContainerFilterStatus(nextFilterStatus);
    } else {
      const indexItem = containerFilterStatus.findIndex((val) => val === value);

      const nextFilterStatus = [...containerFilterStatus];
      nextFilterStatus.splice(indexItem, 1);

      setContainerFilterStatus(nextFilterStatus);
    }
  };

  const showFilterTransactionStatus = !(
    'orderCategory' in router.query && router.query.orderCategory === 'offline'
  );

  return (
    <>
      <div
        className="h-full bg-white lg:!max-h-[70vh] lg:pb-14"
        style={{
          maxHeight: `${windowHeight - 140}px`,
        }}
      >
        <div
          className="no-scrollbar h-full flex flex-col overflow-y-auto lg:scrollbar-hide lg:pr-5 lg:!max-h-[50vh]"
          style={{
            maxHeight: `${windowHeight - 140}px`,
          }}
        >
          <div className="flex flex-col lg:pb-4">
            <Accordion
              title="Jenis Transaksi"
              classNameContainer="!border-0"
              classNameDetails="!py-0"
              classTitleWrapper="px-4 lg:px-0"
              classNameSummary="border-b border-reliableBlack10 py-[20px] font-semibold"
              classNameChildrenWrapper="text-start font-normal text-reliableBlack leading-relaxed px-3 lg:leading-relaxed lg:px-0"
              activeIcon={<DropUpArrow />}
              inactiveIcon={<DropDownArrow />}
              open={isDefaultOpen}
            >
              {filterOptions.filterType.map((val) => (
                <div
                  key={val.value}
                  className="py-4 border-b-[1px] border-[#F4F4F4] last:mb-2 first:pt-5"
                  onClick={() =>
                    onChangeFilterType({
                      value: val.value,
                      checked: !containerFilterType.includes(val.value),
                    })
                  }
                >
                  <CheckboxMultiple
                    label={val.label}
                    value={val.value}
                    containerClassName="!mb-0"
                    className="text-[#393536] checkbox-wrapper-others !gap-4 px-[14px] lg:px-[11.5px]"
                    labelClassName="pointer-events-none"
                    checked={containerFilterType.includes(val.value)}
                    onChange={(e) =>
                      onChangeFilterType({ value: e.target.value, checked: e.target.checked })
                    }
                  />
                </div>
              ))}
            </Accordion>

            {showFilterTransactionStatus && (
              <Accordion
                title="Status Transaksi"
                classNameContainer="!border-0"
                classNameDetails="!py-0"
                classTitleWrapper="px-4 lg:px-0"
                classNameSummary="border-b border-reliableBlack10 py-[20px] font-semibold"
                classNameChildrenWrapper="text-start font-normal text-reliableBlack leading-relaxed px-3 lg:leading-relaxed lg:px-0"
                activeIcon={<DropUpArrow />}
                inactiveIcon={<DropDownArrow />}
                open={isDefaultOpen}
              >
                {filterOptions.filterStatus.map((val) => (
                  <div
                    key={val.value}
                    className="py-4 border-b-[1px] border-[#F4F4F4] last:border-none"
                    onClick={() =>
                      onChangeFilterStatus({
                        value: val.value,
                        checked: !containerFilterStatus.includes(val.value),
                      })
                    }
                  >
                    <CheckboxMultiple
                      label={val.label}
                      value={val.value}
                      containerClassName="!mb-0"
                      className="text-[#393536] checkbox-wrapper-others !gap-4 px-[14px] lg:px-[11.5px]"
                      checked={containerFilterStatus.includes(val.value)}
                      labelClassName="pointer-events-none"
                      onChange={(e) =>
                        onChangeFilterStatus({ value: e.target.value, checked: e.target.checked })
                      }
                    />
                  </div>
                ))}
              </Accordion>
            )}
          </div>

          <BtnConfirm
            id="btn-filter-modal"
            className="!bottom-0 fixed right-0 bg-supportiveRed text-white !p-4 md:!rounded-none lg:!py-4 lg:!bottom-[20px] lg:!w-[95%] lg:!left-1/2 lg:!-translate-x-1/2 lg:!rounded"
            block={true}
            iconType="icon"
            onClick={() => onSubmit(containerFilterType, containerFilterStatus)}
          >
            <div className="flex justify-end items-center gap-2 w-full lg:justify-center">
              <p className="text-base font-bold leading-none">PILIH</p>
              {!isLargeScreen && <ArrowForward size={28} color="#FFFFFF" />}
            </div>
          </BtnConfirm>
        </div>
      </div>
    </>
  );
}

export default FilterModalTrackingTransaction;
